import { render, staticRenderFns } from "./SingleInspiration.vue?vue&type=template&id=1d6da740"
import script from "./SingleInspiration.vue?vue&type=script&lang=js"
export * from "./SingleInspiration.vue?vue&type=script&lang=js"
import style0 from "./SingleInspiration.vue?vue&type=style&index=0&id=1d6da740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports